<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        class="add"
        v-role="['1', '3']"
        size="small"
        @click="upload"
      >
        <i class="el-icon-upload"></i>
        上传组别
      </el-button>
      <el-button
        type="danger"
        size="small"
        v-role="['3']"
        class="delete"
        @click="downLoad"
      >
        <i class="el-icon-delete"></i>下载组别
      </el-button>
      <el-button
        type="danger"
        size="small"
        v-role="['1']"
        class="delete"
        @click="downLoadAll"
      >
        <i class="el-icon-delete"></i>下载组别
      </el-button>
      <el-button
        type="warning"
        size="small"
        v-role="['1', '3']"
        class="delete"
        @click="batchSetting"
      >
        <i class="el-icon-delete"></i>批量设置
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item label="组别类型">
            <el-select
              v-model="searchForm.type"
              clearable
              placeholder="请选择组别类型"
            >
              <el-option
                v-for="item in groupOptions"
                :key="item"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名费">
            <el-input
              v-model="searchForm.entryFee"
              clearable
              placeholder="请输入报名费"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input
              placeholder="请输入组别名称/代码"
              clearable
              v-model="searchForm.keyword"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="code"
        align="center"
        label="组别代码"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="组别名称"
      ></el-table-column>
      <el-table-column
        prop="danceType"
        align="center"
        label="舞种"
      ></el-table-column>
      <el-table-column
        prop="type"
        align="center"
        label="类型"
      ></el-table-column>
      <el-table-column
        prop="sequence"
        width="100"
        v-if="isAdmin()"
        align="center"
        label="组别顺序"
      >
      </el-table-column>
      <el-table-column
        prop="entryFee"
        align="center"
        width="100"
        label="报名费"
      ></el-table-column>
      <el-table-column
        prop="remark"
        align="center"
        width="250"
        label="备注"
      ></el-table-column>
      <el-table-column
        prop="ext"
        align="center"
        v-if="isShowExt"
        label="类型"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="150"
        fixed="right"
        align="center"
        v-if="isAdmin()"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="deleteGroup(scope.row)"
            class="btnopt"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="editGroup(scope.row)"
            class="btnopt"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 30, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="'组别导入'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-upload
          ref="uploader"
          class="upload-demo"
          action=""
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :http-request="uploadFile"
          :limit="1"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
        </el-upload>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="'编辑组别'"
      :inline="true"
      :visible.sync="dialogEditFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="组别名称" prop="name">
          <el-input disabled v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="组别代码" prop="code">
          <el-input disabled v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="报名费" prop="entryFee">
          <el-input-number
            v-model="form.entryFee"
            :controls="false"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="缴费类型" prop="feeType">
          <el-select v-model="form.feeType">
            <el-option
              v-for="item in feeTypeOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'批量设置组别'"
      :inline="true"
      :visible.sync="dialogEditBatchFormVisible"
    >
      <el-form
        :model="formBatch"
        label-position="right"
        label-width="110px"
        :rules="formBatchRules"
        ref="formBatch"
      >
        <el-form-item label="组别类型">
          <el-select
            v-model="formBatch.type"
            clearable
            @change="loadGroupPriceList"
            placeholder="请选择组别类型"
          >
            <el-option
              v-for="item in groupOptions"
              :key="item"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格类型" prop="priceType">
          <el-select v-model="formBatch.priceType">
            <el-option
              v-for="item in priceListOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报名费" prop="entryFee">
          <el-input-number
            v-model="formBatch.entryFee"
            :controls="false"
          ></el-input-number>
          <el-checkbox v-model="formBatch.isChangePrice"
            >同步更新价格</el-checkbox
          >
        </el-form-item>
        <el-form-item label="缴费类型" prop="feeType">
          <el-select v-model="formBatch.feeType">
            <el-option
              v-for="item in feeTypeOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditBatchFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFormBatch" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/group'
import Index from '../views/Index.vue'
export default {
  components: { Index },
  props: [
    'matchId'
  ],
  data () {
    return {
      isLoading: false,
      dialogFormVisible: false,
      dialogEditFormVisible: false,
      dialogEditBatchFormVisible: false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      groupOptions: [],
      isShowExt: false,
      priceListOptions: [],
      searchForm: {
        keyword: null,
        entryFee: null,
        type: null,
        page: 1,
        pageSize: 20,
        matchId: this.matchId
      },
      feeTypeOptions: [
        { name: '一对（组别计费）', value: 0 },
        { name: '单人（人次计费）', value: 1},
        { name: '一队（团舞）', value: 2 },
      ],
      form: {
        id: 0,
        feeType: null,
        entryFee: null,
        name: ''
      }, formRules: {
        entryFee: [{ required: true, message: '请输入报名费', trigger: 'blur' }],
        feeType: [{ required: true, message: '请选择计费方式', trigger: 'blur' }]
      },
      formBatch: {
        feeType: null,
        entryFee: null,
        priceType: null,
        type: null,
        isChangePrice: false,
        matchId:this.matchId
      }, formBatchRules: {
        entryFee: [{ required: true, message: '请输入报名费', trigger: 'blur' }],
        feeType: [{ required: true, message: '请选择计费方式', trigger: 'blur' }]
      }
    }
  },
  methods: {
    ishaveextdata () {
      var isShow = false
      this.tableListData.forEach(function (item) { if (item.ext != null && item.ext != '') { isShow = true; return; } })
      return isShow
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    loadGroupPriceList () {
      API.selectEntryFee({ matchId: this.matchId, groupType: this.formBatch.type }).then(res => {
        if (res.code == 0) {
          var options = []
          for (var i = 0; i < res.result.length; i++) {
            options.push({ name: res.result[i], value: res.result[i] })
          }
          this.formBatch.priceType = null;
          this.priceListOptions = options;
        }
        else {
          this.priceListOptions = [];
        }
      })
    },
    batchSetting () {
      this.dialogEditBatchFormVisible = true;
      this.$nextTick(() => {
        this.$refs['formBatch'].resetFields();
        this.formBatch = {
          feeType: null,
          entryFee: null,
          priceType: null,
          type: null,
          isChangePrice: false,
          matchId:this.matchId
        }
      })
    },
    isHostOrAdmin () {
      return sessionStorage.getItem('userType') == "3" || sessionStorage.getItem('userType') == "1"
    },
    isAdmin () {
      return sessionStorage.getItem('userType') == "1"
    },
    changeSequence (groupId) {
      API.changeSequence({ id: groupId, sequence: this.sequence, isUpdateAll: this.isUpdateAll }).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          this.search()
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    editGroup (row) {
      API.get({ id: row.id }).then(result => {
        this.dialogEditFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogEditFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
        }
        else {
          this.isLoading = false
        }
      });
    },
    submitFormBatch () {
      let that = this;
      this.isLoading = true
      this.$refs.formBatch.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.formBatch)
          API.editBatch(params).then((data) => {
            if (data.code == 0) {
              that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
              that.dialogEditBatchFormVisible = false;
              that.$refs['formBatch'].resetFields();

              that.search();
            } else {
              this.$message.error({ showClose: true, message: data.message, duration: 2000 });
            }
            that.isLoading = false
          }, function (err) {
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
            that.isLoading = false
          }).catch(function (error) {
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
            that.isLoading = false
          })
        }
        else {
          this.isLoading = false
        }
      });
    },
    deleteGroup (row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          console.log(result)
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: '系统错误', duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '123', duration: 2000 })
        })
      }).catch(() => { })
    },
    upload () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.$refs['uploader'].clearFiles();
      })
    },
    uploadFile (item) {
      const form = new FormData();
      form.append('matchId', this.matchId);
      form.append('file1', item.file);
      API.import(form).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '导入成功!'
          });
          this.search()
          API.selectType({ matchId: this.matchId }).then(res => {
            this.groupOptions = res.result;
          });
          this.dialogFormVisible = false;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      }).catch(err => {
      })
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data
          this.total = result.result.recordCount
          this.isShowExt = this.ishaveextdata()
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        console.log(error)
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    doSearch () {
      this.search.page = 1
      this.search()
    },
    downLoad: function () {      
      API.downloadExport({ matchId: this.matchId }).then(res => {
        var content = res;
        var blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var fileName = "组别设项.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    downLoadAll:function(){
       this.$confirm('下载文件格式选择', '提示', {
          confirmButtonText: '导出记分使用',
          cancelButtonText: '导出数据',
          type: 'warning'
        }).then(() => {
          API.downloadExport({ matchId: this.matchId }).then(res => {
        var content = res;
        var blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var fileName = "组别设项.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
        }).catch(() => {
           API.download({ matchId: this.matchId }).then(res => {
        var content = res;
        var blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var fileName = "组别设项.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
        });
      
    }
  },
  computed: {
  },
  mounted () {
    this.search()
    API.selectType({ matchId: this.matchId }).then(res => {
      this.groupOptions = res.result;
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Group.vue